import APIEntry from "@/api/APIEntry.js";
import axios from "axios";
import store from "../store";

/**
 * Global mapping interfaces
 */
export default Object.freeze({
  /**
   * api entry 매칭 시키기
   */
  entry: function () {
    if (!arguments.length) {
      return null;
    }
    const args = Array.from(arguments);
    const entry = args.shift();

    const match = store.state.entries[entry];

    if (typeof match === undefined) {
      return null;
    }

    const mall_id = sessionStorage.getItem("supply_mall_id");
    const app_code = store.state.app_code;

    if (match.requireAuth && (!mall_id || !app_code)) {
      return null;
    }

    const merged_args = [app_code, mall_id].concat(args);
    let uri = match.path;
    merged_args.forEach((item, index) => {
      uri = uri.replace(`{${index}}`, item);
    });

    return new APIEntry(uri, match.method, match.target);
  },
  /**
   * api request
   * @param {APIEntry} entry API URI 맵핑 객체
   * @param {Object} payload 요청 본문 파라미터
   */
  api: async function (entry, payload) {
    if (entry === null) {
      throw new Error("'entry' parameter is required.");
    }

    // status code 확인 하여 토큰 갱신 처리
    axios.defaults.headers.common["Content-Type"] = "application/json";
    axios.defaults.headers.Authorization = sessionStorage.getItem("supply_access_token");

    await axios.interceptors.response.use(null, async (error) => {
      const mall_id = sessionStorage.getItem("supply_mall_id");
      console.error("error.response", error);
      if (error.response.status === 401) {
        await store.dispatch("common/getRefreshToken");
        error.config.headers.Authorization = sessionStorage.getItem("supply_access_token");
        return axios.request(error.config);
      } else if (
        error.config &&
        error.response &&
        error.response.status === 404 &&
        error.response.data.message &&
        error.response.data.message == "Not found mall_id"
      ) {
        alert(
          "카페24 인증키 값이 만료되었습니다.\n앱스토어 목록에서 다시 접속해주세요."
        );
        location.href = `https://${mall_id}.cafe24.com/disp/admin/shop1/myapps/list`;
        await new Promise((resolve) => {
          setTimeout(resolve, 2000);
        });
      } else if (
        error.config &&
        error.response &&
        error.response.status === 403 &&
        error.response.data.message &&
        error.response.data.message == "RefreshToken expired"
      ) {
        alert(
          "카페24 인증키 값이 만료되었습니다.\n앱스토어 목록에서 다시 접속해주세요."
        );
        location.href = `https://${mall_id}.cafe24.com/disp/admin/shop1/myapps/list`;
        await new Promise((resolve) => {
          setTimeout(resolve, 1000);
        });
      }
      return error;
    });

    let statement = {
      baseURL: store.state.api_url,
      url: entry.getPath(),
      method: entry.getMethod(),
    };

    if (payload) {
      if (["POST", "DELETE", "PUT"].includes(entry.getMethod())) {
        statement.data = payload;
      } else {
        statement.params = payload;
      }
    }
    let res = await axios(statement);
    return res.data;
  },
});
